import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { IEditableSectionRenderProps } from "@/components/EditableSection";
import { Group } from "@/components/Group";
import { Text } from "@/components/Text";
import { TextListWithDot } from "@/components/TextListWithDot";
import { TStyleFlexDirection } from "@/eworkitComponents";
import { useCodelistTranslation } from "@/hooks/Codelist";
import { IConsultantProfileSectionProps } from "@/views/components/ConsultantProfile/Sections/types";

interface IWorkPreferencesSectionProps extends IConsultantProfileSectionProps, Partial<IEditableSectionRenderProps> {
  direction?: TStyleFlexDirection;
}

export const WorkPreferencesSection: FC<IWorkPreferencesSectionProps> = memo<IWorkPreferencesSectionProps>(
  ({ record, direction = "row" }) => {
    const { workPreferences } = record;

    const { t } = useTranslation("session");
    const tCodelist = useCodelistTranslation();

    const workPreferencesSorted = workPreferences.sort((a, b) => (a > b ? -1 : 1));

    return (
      <Group label={t("CONSULTANT_PROFILES.DETAIL.WORK_PREFERENCES.LABEL")} direction={direction}>
        {workPreferencesSorted.length > 0 ? (
          <TextListWithDot>
            {workPreferencesSorted.map(preference => (
              <Text key={preference} size="md">
                {tCodelist("work-preference", preference)}
              </Text>
            ))}
          </TextListWithDot>
        ) : (
          <Text size="md" color="grey3">
            {t("CONSULTANT_PROFILES.DETAIL.WORK_PREFERENCES.NO_ITEMS")}
          </Text>
        )}
      </Group>
    );
  },
);
